import { Button, Container, EmptyState, LostBalloon } from '@giftgroup/ui';
import { Link } from 'react-router';
import { commonCopy } from '../copy/common';

/** The friendly 404 (doc 05). Also stands in for routes that land in later milestones. */
export function NotFound() {
  return (
    <Container width="readable">
      <EmptyState
        art={<LostBalloon />}
        title={commonCopy.notFound.heading}
        primaryAction={
          <Button asChild>
            <Link to="/">{commonCopy.notFound.action}</Link>
          </Button>
        }
      >
        {commonCopy.notFound.body}
      </EmptyState>
    </Container>
  );
}
